import Entity from "./Entity";

export default class Map extends Entity {
    constructor(data) {
        super(data);

        this.attributeKeys = [
            "id", "name", "bundleIds", "sortMethod", "showCalculatedDistance", "openMapObjectListByDefault", "mapBannerUrl", 
            "statusAvailableOnMap", "statusVisibleByDefault", "mapDefinitionFilename", "languageAvailability", "legacyOpeningMessages"
        ];
    }

    getId() {
        return this.get("id");
    }

    getName() {
        return this.get("name");
    }

    getBundleIds() {
        return this.get("bundleIds");
    }

    getSortMethod() {
        return this.get("sortMethod");
    }

    getMapBannerUrl() {
        return this.get("mapBannerUrl");
    }
}